import { render } from "./building.vue?vue&type=template&id=d1d52dd4"
import script from "./building.vue?vue&type=script&lang=js"
export * from "./building.vue?vue&type=script&lang=js"

import "./building.vue?vue&type=style&index=0&id=d1d52dd4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/createProject/building.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d1d52dd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d1d52dd4', __exports__)) {
    api.reload('d1d52dd4', __exports__)
  }
  
  module.hot.accept("./building.vue?vue&type=template&id=d1d52dd4", () => {
    api.rerender('d1d52dd4', render)
  })

}


export default __exports__